import { memoizeDeep } from "../common/utilities";
const setTheme = memoizeDeep(function (_ref) {
  let {
    modalselect,
    disabled
  } = _ref;
  let cssRoot = {},
      cssLabel = {},
      cssFieldWrapper = {},
      cssField = {},
      cssSummaryText = {},
      cssSelectionDetails = {},
      cssPanel = {},
      cssInlineFilterWrapper = {},
      cssFindByBoundingBox = {},
      cssFindByWrapper = {},
      cssPaginatorWrapper = {},
      cssCancelButton = {},
      cssFooterError = {};

  if (modalselect) {
    cssRoot = modalselect.root;
    cssLabel = modalselect.label;
    cssFieldWrapper = modalselect.fieldWrapper;
    cssField = disabled ? modalselect.modifiers.disabled : {};
    cssSummaryText = modalselect.summaryText;
    cssSelectionDetails = modalselect.selectionDetails; // modal select panel related properties

    cssPanel = modalselect.panel;
    cssInlineFilterWrapper = modalselect.inlineFilterWrapper;
    cssFindByBoundingBox = modalselect.findByBoundingBox;
    cssPaginatorWrapper = modalselect.paginatorWrapper;
    cssFindByWrapper = modalselect.findByWrapper;
    cssCancelButton = modalselect.cancelButton;
    cssFooterError = modalselect.footerError;
  }

  return {
    cssRoot,
    cssLabel,
    cssFieldWrapper,
    cssField,
    cssSummaryText,
    cssSelectionDetails,
    cssInlineFilterWrapper,
    cssFindByBoundingBox,
    cssFindByWrapper,
    cssPaginatorWrapper,
    // properties related to panel
    cssPanel,
    cssCancelButton,
    cssFooterError
  };
});
export default function (_ref2) {
  var _theme$components;

  let {
    theme,
    disabled
  } = _ref2;
  const modalselect = theme === null || theme === void 0 ? void 0 : (_theme$components = theme.components) === null || _theme$components === void 0 ? void 0 : _theme$components.modalselect;
  return setTheme({
    modalselect,
    disabled
  });
}